import type { ReactNode } from "react";

import { SCORECARD_VERDICT_PILL } from "../../constants";

import ScorecardScoreDeltaBadge from "./ScorecardScoreDeltaBadge";

import { cn } from "@/lib/utils";

interface ScorecardScoreSummaryProps {
  score?: ReactNode;
  drift?: number | null;
  meta?: ReactNode;
  verdictLabel?: ReactNode;
  verdictClassName?: string;
  trailingContent?: ReactNode;
  containerClassName?: string;
  scoreClassName?: string;
}

const ScorecardScoreSummary = ({
  score,
  drift,
  meta,
  verdictLabel,
  verdictClassName,
  trailingContent,
  containerClassName,
  scoreClassName,
}: ScorecardScoreSummaryProps) => (
  <div className={cn("flex flex-wrap items-center gap-x-3 gap-y-2", containerClassName)}>
    {score !== null && score !== undefined ? (
      <span className={cn("text-3xl font-semibold tabular-nums text-foreground", scoreClassName)}>
        {score}
      </span>
    ) : null}
    <ScorecardScoreDeltaBadge drift={drift} />
    {meta ? <span className="min-w-0 text-sm text-muted-foreground">{meta}</span> : null}
    {verdictLabel ? (
      <span
        className={cn(
          "shrink-0 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium",
          SCORECARD_VERDICT_PILL,
          verdictClassName,
        )}
      >
        {verdictLabel}
      </span>
    ) : null}
    {trailingContent}
  </div>
);

export default ScorecardScoreSummary;
